import { AbstractFreewheelRequestFactory } from 'tag/ts/tag/ads/freewheel/factories/AbstractFreewheelRequestFactory';
import { FreewheelDaiSsbRequest } from 'tag/ts/tag/ads/freewheel/requests/FreewheelDaiSsbRequest';
import { ITagAbstractClassArgument } from 'tag/ts/tag/interfaces/arguments/ITagAbstractClassArgument';

/**
 * @copyright © Paramount Streaming
 * @author  Zeeshan Ahmad
 * @description Used to create Freewheel DAI SSB request
 */
export class FreewheelDaiSsbRequestFactory extends AbstractFreewheelRequestFactory {

	constructor( argument: ITagAbstractClassArgument ) {
		super(
			{
				...argument,
				name: 'FreewheelDaiSsbRequestFactory'
			}
		);
	}

	/**
	 * @description Creates and returns a FreewheelDaiSsbRequest instance
	 * @return {FreewheelDaiSsbRequest}
	 */
	createRequest(): FreewheelDaiSsbRequest {
		const request = new FreewheelDaiSsbRequest( { tag: this.tag } );
		this?.logger?.log( 'createRequest', 'returning FreewheelDaiSsbRequest:', request );
		return request;
	}
}